import React, { useState } from 'react';
import axios from 'axios';

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.post('/api/subscribe', { email });
      setSuccess(true);
      setEmail('');
      
      // Clear success message after 5 seconds
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch (err) {
      console.error('Subscription error:', err);
      setError(err.response?.data?.message || 'Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="newsletter">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-4 font-heading">Stay Updated</h2>
        <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
          Subscribe to our newsletter to receive the latest insights on AI, machine learning, and digital transformation.
        </p>
        
        {error && (
          <div className="bg-red-800 text-white p-3 rounded-md mb-4 max-w-md mx-auto">
            <p>{error}</p>
          </div>
        )}
        
        {success && (
          <div className="bg-green-700 text-white p-3 rounded-md mb-4 max-w-md mx-auto">
            <p>Thank you for subscribing to our newsletter!</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-2">
            <input 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address" 
              className="flex-grow px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" 
              disabled={loading}
            />
            <button 
              type="submit" 
              className="btn btn-primary py-3 px-6"
              disabled={loading}
            >
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>
          <p className="text-sm text-gray-400 mt-4">We respect your privacy. Unsubscribe at any time.</p>
        </form>
      </div>
    </div>
  );
};

export default NewsletterSubscription;
